module.exports = __webpack_public_path__ + "img/type_32-b-150_3.prt.ba5b41a0.jpg";